import { MessageSquareText } from "lucide-react";
import { useEnquiry } from "@/context/EnquiryContext";

export const WhatsAppButton = () => {
  const { openEnquiry } = useEnquiry();
  return (
    <button
      type="button"
      data-testid="enquire-float-button"
      onClick={() => openEnquiry("advisor")}
      aria-label="Send Affinity an enquiry"
      className="glass fixed z-[70] right-5 bottom-[86px] md:right-7 md:bottom-[100px] flex items-center gap-3 pl-4 pr-5 py-3 rounded-full text-sm font-semibold text-[var(--cream)] hover:border-[var(--gold)] transition-[border-color,transform] duration-300 hover:-translate-y-1"
    >
      <span className="grid place-items-center w-9 h-9 rounded-full bg-[var(--gold)] text-[var(--navy)]"><MessageSquareText size={18} /></span>
      <span className="hidden sm:inline">Enquire now</span>
    </button>
  );
};
